export class Constants {
  // Server URL - using HTTPS since the application is served over HTTPS
  // In production, this should be set via environment files
  public static SERVER_URL = '';
  public static REQUEST_TIMEOUT = 30000;
  public static DISABLE_NO_INTERNET_ALERT = false;
}
